import type { DriverType } from '@ria-client/supergraph/marketplace/types';
import { Driver } from './driver';

export interface DriversSectionProps {
  drivers: DriverType[];
}

export function DriversSection({ drivers }: DriversSectionProps) {
  return (
    <div className="grid w-full grid-cols-2 md:grid-cols-4">
      {drivers.map((driver, index) => {
        const isLastMobileRow = index >= drivers.length - 2;
        const className = [
          index % 2 === 0 ? 'border-r border-border md:border-r-0' : '',
          !isLastMobileRow ? 'border-b border-border md:border-b-0' : '',
          index < drivers.length - 1 ? 'md:border-r md:border-border' : '',
        ]
          .filter(Boolean)
          .join(' ');

        return <Driver className={className} driver={driver} key={`driver-${index}`} />;
      })}
    </div>
  );
}
